import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6b426024"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "hmd-btn form-btn" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("编辑")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("新建")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("编辑品牌")
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "新建品牌", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "品牌编号将自动生成", -1))
const _hoisted_7 = { class: "text-grey" }
const _hoisted_8 = { class: "text-grey" }

export function render(_ctx, _cache) {
  const _component_hmd_empty_link = _resolveComponent("hmd-empty-link")
  const _component_a_button = _resolveComponent("a-button")
  const _component_a_input = _resolveComponent("a-input")
  const _component_a_form_item = _resolveComponent("a-form-item")
  const _component_material_category_select = _resolveComponent("material-category-select")
  const _component_a_textarea = _resolveComponent("a-textarea")
  const _component_a_form = _resolveComponent("a-form")
  const _component_a_skeleton = _resolveComponent("a-skeleton")
  const _component_a_modal = _resolveComponent("a-modal")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isEdit)
      ? (_openBlock(), _createBlock(_component_hmd_empty_link, {
          key: 0,
          onClick: _ctx.showEditModal
        }, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        }, 8, ["onClick"]))
      : _renderSlot(_ctx.$slots, "addBrand", {
          key: 1,
          showCreateModal: _ctx.showCreateModal
        }, () => [
          _createVNode(_component_a_button, {
            type: "primary",
            onClick: _ctx.showCreateModal
          }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          }, 8, ["onClick"])
        ], true),
    _createVNode(_component_a_modal, {
      visible: _ctx.visible,
      "onUpdate:visible": _cache[4] || (_cache[4] = $event => ((_ctx.visible) = $event)),
      "confirm-loading": _ctx.createLoading || _ctx.editLoading,
      keyboard: false,
      centered: true,
      "mask-closable": false,
      destroyOnClose: "",
      zIndex: 1200,
      onOk: _ctx.submit,
      onCancel: _ctx.closeModal
    }, {
      title: _withCtx(() => [
        (_ctx.isEdit)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _hoisted_4
            ], 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _hoisted_5,
              _hoisted_6
            ], 64))
      ]),
      default: _withCtx(() => [
        _createVNode(_component_a_skeleton, {
          loading: _ctx.detailLoading,
          active: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form, {
              layout: "vertical",
              model: _ctx.formRef,
              rules: _ctx.formRules
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_form_item, {
                  label: "品牌名称",
                  name: "name"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_input, {
                      value: _ctx.formRef.name,
                      "onUpdate:value": _cache[0] || (_cache[0] = $event => ((_ctx.formRef.name) = $event)),
                      valueModifiers: { trim: true },
                      placeholder: "请输入品牌名称",
                      maxlength: 20
                    }, {
                      suffix: _withCtx(() => [
                        _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.formRef.name.length) + "/20", 1)
                      ]),
                      _: 1
                    }, 8, ["value"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_form_item, {
                  label: "英文名称",
                  name: "enName"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_input, {
                      value: _ctx.formRef.enName,
                      "onUpdate:value": _cache[1] || (_cache[1] = $event => ((_ctx.formRef.enName) = $event)),
                      valueModifiers: { trim: true },
                      placeholder: "请输入品牌的英文全称",
                      maxlength: 40
                    }, {
                      suffix: _withCtx(() => [
                        _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.formRef.enName.length) + "/40", 1)
                      ]),
                      _: 1
                    }, 8, ["value"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_form_item, {
                  label: "所属分类",
                  name: "materialCategoryId"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_material_category_select, {
                      value: _ctx.formRef.materialCategoryId,
                      "onUpdate:value": _cache[2] || (_cache[2] = $event => ((_ctx.formRef.materialCategoryId) = $event)),
                      multiple: true,
                      isRelative: _ctx.isRelative
                    }, null, 8, ["value", "isRelative"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_form_item, {
                  label: "备注说明",
                  name: "remark"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_textarea, {
                      value: _ctx.formRef.remark,
                      "onUpdate:value": _cache[3] || (_cache[3] = $event => ((_ctx.formRef.remark) = $event)),
                      placeholder: "请输入说明，最多200字",
                      rows: 4,
                      maxlength: 200,
                      "show-count": ""
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["model", "rules"])
          ]),
          _: 1
        }, 8, ["loading"])
      ]),
      _: 1
    }, 8, ["visible", "confirm-loading", "onOk", "onCancel"])
  ]))
}